export class ScrollLock {
    public isLocked = false;

    // tslint:disable-next-line: variable-name
    private static _instance: ScrollLock;
    private bodyScrollPosition = 0;

    static get instance() {
        return this._instance || (this._instance = new this());
    }

    public lock(): void {
        const webContainer = document.querySelector('.container');
        const mobileContainer = document.querySelector('.page-container');
        this.bodyScrollPosition = window.scrollY;

        if (webContainer || mobileContainer) {
            document.body.setAttribute(
                'style',
                'overflow: hidden !important; position: fixed !important; top: -' +
                this.bodyScrollPosition +
                'px;',
            );
            this.isLocked = true;
        }
    }

    public unlock(): void {
        const webContainer = document.querySelector('.container');
        const mobileContainer = document.querySelector('.page-container');

        if (webContainer || mobileContainer) {
            document.body.removeAttribute('style');
            window.scrollTo(0, this.bodyScrollPosition);
            this.isLocked = false;
        }
    }
}
